import React, { useEffect, useState } from 'react';
import { getFileUrl, useGetFileUrl } from 'shared-pages/common/db-help-func';
import { useApolloClient } from '@apollo/client';
//import { Col, Image } from 'react-bootstrap';
//import Image from 'react-image-enlarger';

/*
export const FileRepoImage = ({ fileId, ...rest }) => {
  const client = useApolloClient();
  // Signature Url
  const [url, setUrl] = useState('');
  useEffect(() => {
    if (fileId) {
      getFileUrl(client, fileId).then(result => {
        setUrl(result);
      });
    }
  }, [client, fileId]);

  return <Image src={url} {...rest} />;
};
*/
export const FileRepoImage = ({
  fileId,
  maxWidth = '100%',
  maxHeight = '4rem',
  minHeight = null,
  ...rest
}) => {
  const url = useGetFileUrl(fileId);

  const [zoomed, setZoomed] = useState(false);

  if (!url) return null;

  return (
    <>
      <img
        style={{
          maxWidth,
          maxHeight,
          objectFit: 'contain',
          objectPosition: '0% 0%',
          minHeight,
          cursor: 'zoom-in',
        }}
        src={url}
        onClick={() => setZoomed(true)}
        {...rest}
      />
      {zoomed && (
        <div
          role="dialog"
          aria-modal="true"
          onClick={() => setZoomed(false)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            cursor: 'zoom-out',
          }}
        >
          <img
            src={url}
            style={{ maxWidth: '95vw', maxHeight: '95vh', objectFit: 'contain' }}
            onClick={(event) => event.stopPropagation()}
          />
        </div>
      )}
    </>
  );
};
